module.exports = __webpack_public_path__ + "img/HendrickCar.5e78a82d.svg";